export default __webpack_public_path__ + "static/media/illustration.917b3ef9.svg";